import './ImageView.less';
import React, {useState, useEffect} from 'react';
import AspectContainer from "../../../components/aspect-container/AspectContainer";
import Images from '../../../models/image/Images';

export default function ImageView({image, ratio}) {

    return <div className="image-view">
        <AspectContainer ratio={ratio}>
            <img
                src={Images.getUrl(image)}
                srcSet={Images.getAttrSrcset(image)}
                sizes={Images.getAttrSizes(image)}
                title={image.title}
                alt={image.title}
            />
        </AspectContainer>
    </div>;
}
